import yup from './yupUtil';
import {
	validateZeroEnrollmentReason,
	validateToBeLessThanOrEqualToFieldValue,
	validateToBeExactlyEqualToFieldValue,
} from './commonFormValidation';

// schema declaration..
export const eighthGradeStepFormSchema = yup.object().shape({
	totalVaricelleCount: validateToBeExactlyEqualToFieldValue('enrolledStudentCount'),
	totalTdapCount: validateToBeExactlyEqualToFieldValue('enrolledStudentCount'),
	enrolledStudentCount: yup.number().required('Enrollment count is required').integer('Only whole numbers can be entered'),
	zeroEnrollmentReason: validateZeroEnrollmentReason('enrolledStudentCount'),
	reqMetVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	reqMetTdapCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	permMedicalVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	permMedicalTdapCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	indepStudyVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	indepStudyTdapCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	homeBasedVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	homeBasedTdapCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	condMissingVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	tempMedicalExempVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	tempMedicalExempTdapCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	reqNotMetVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	reqNotMetTdapCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	iepVaricelleCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	iepTdapCount: validateToBeLessThanOrEqualToFieldValue('enrolledStudentCount'),
	metadata: yup.object().shape({
		submittedDate: yup.string(),
		revisedDate: yup.string()
	}),
});

// form initialization..
export const eighthGradeStepFormModel = {
	totalVaricelleCount: 0,
	totalTdapCount: 0,
	enrolledStudentCount: '',
	zeroEnrollmentReason: '',
	reqMetVaricelleCount: 0,
	reqMetTdapCount: 0,
	permMedicalVaricelleCount: 0,
	permMedicalTdapCount: 0,
	iepVaricelleCount: 0,
	iepTdapCount: 0,
	indepStudyVaricelleCount: 0,
	indepStudyTdapCount: 0,
	homeBasedVaricelleCount: 0,
	homeBasedTdapCount: 0,
	condMissingVaricelleCount: 0,
	tempMedicalExempVaricelleCount: 0,
	tempMedicalExempTdapCount: 0,
	reqNotMetVaricelleCount: 0,
	reqNotMetTdapCount: 0,
	metadata: {
		submittedDate: "",
		revisedDate: ""
	}
};
